import { IntervalsRange } from "@/engine/engine";
import {
  HGIntersection,
  HGIntersectionType,
  HGInterval,
  HGTimeRecordPlus,
} from "./types";

export function calculateIntersection(
  parentRange: [bigint, bigint],
  childRange: [bigint, bigint | null],
): HGIntersection {
  const parentStart = parentRange[0];
  const parentEnd = parentRange[1];

  const childStart = childRange[0];
  const childEnd = childRange[1];

  if (
    parentStart > parentEnd ||
    childStart > parentEnd ||
    (childEnd && (childEnd < childStart || childEnd < parentStart))
  ) {
    return {
      offsets: null,
      intersectionType: HGIntersectionType.None,
    };
  }

  let intersectionType = HGIntersectionType.None;
  let begin = 0;
  let end = 100;
  let finished = true;
  const parentDuration = Math.abs(Number(parentEnd - parentStart) + 1);

  if (!childEnd) {
    finished = false;
    if (childStart < parentStart) {
      intersectionType = HGIntersectionType.Transit;
    } else if (childStart == parentStart) {
      intersectionType = HGIntersectionType.Starts;
    } else {
      intersectionType = HGIntersectionType.PartRight;
      begin = Math.abs(
        (Number(childStart - parentStart) * 100) / parentDuration,
      );
    }
  } else if (childStart == parentStart && childEnd == parentEnd) {
    intersectionType = HGIntersectionType.Exact;
  } else if (childStart == parentStart && childEnd > parentEnd) {
    intersectionType = HGIntersectionType.Starts;
  } else if (childStart < parentStart && childEnd == parentEnd) {
    intersectionType = HGIntersectionType.Ends;
  } else if (childStart < parentStart && childEnd > parentEnd) {
    intersectionType = HGIntersectionType.Transit;
  } else if (childStart >= parentStart && childEnd <= parentEnd) {
    intersectionType = HGIntersectionType.Contained;
    begin = Math.abs(Number(childStart - parentStart) * 100) / parentDuration;
    end = Math.abs(Number(childEnd) * 100) / parentDuration;
  } else if (childStart >= parentStart) {
    intersectionType = HGIntersectionType.PartRight;
    begin = Math.abs(Number(childStart - parentStart) * 100) / parentDuration;
  } else if (childEnd <= parentEnd) {
    intersectionType = HGIntersectionType.PartLeft;
    end = Math.abs(Number(childEnd) * 100) / parentDuration;
  }

  const intersection = {
    offsets: {
      begin,
      end,
      finished,
    },
    intersectionType,
  };

  return intersection;
}

export function calculateIntersectionOfRecordWithIntervals(
  record: HGTimeRecordPlus,
  interval: HGInterval,
  endInterval: HGInterval | null,
) {
  const intervalRange = IntervalsRange(interval, endInterval, "s");
  const recordRange: [bigint, bigint | null] = [
    record.start_second,
    record.end_interval ? record.end_second : null,
  ];
  return calculateIntersection(intervalRange, recordRange);
}
